import { render, staticRenderFns } from "./fbx-loader.vue?vue&type=template&id=709e5e69"
import script from "./fbx-loader.vue?vue&type=script&lang=js"
export * from "./fbx-loader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports